import React, { ReactElement } from 'react'
import { Box, TextField } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'

type FormFieldProps = {
  field: any
}

export let TopicField = ({ field }: FormFieldProps): ReactElement => (
  <TextField
    label="Topic"
    name={field.name}
    value={field.state.value}
    onChange={(e) => field.handleChange(e.target.value)}
    onBlur={field.handleBlur}
    required
    fullWidth
    sx={{ bgcolor: 'background.paperDark' }}
  />
)

export let SubTopicField = ({ field }: FormFieldProps): ReactElement => (
  <TextField
    label="Sub-Topic"
    name={field.name}
    value={field.state.value}
    onChange={(e) => field.handleChange(e.target.value)}
    onBlur={field.handleBlur}
    required
    fullWidth
    sx={{ bgcolor: 'background.paperDark' }}
  />
)

export let AreaNumberALSField = ({ field }: FormFieldProps): ReactElement => (
  <TextField
    label="Area Number (ALS)"
    name={field.name}
    value={field.state.value}
    onChange={(e) => field.handleChange(e.target.value)}
    onBlur={field.handleBlur}
    fullWidth
    sx={{ bgcolor: 'background.paperDark' }}
    placeholder="Optional"
  />
)

export let AreaNumberBLSField = ({ field }: FormFieldProps): ReactElement => (
  <TextField
    label="Area Number (BLS)"
    name={field.name}
    value={field.state.value}
    onChange={(e) => field.handleChange(e.target.value)}
    onBlur={field.handleBlur}
    fullWidth
    sx={{ bgcolor: 'background.paperDark' }}
    placeholder="Optional"
  />
)

export let NotesField = ({ field }: FormFieldProps): ReactElement => (
  <TextField
    label="Notes"
    name={field.name}
    value={field.state.value}
    onChange={(e) => field.handleChange(e.target.value)}
    onBlur={field.handleBlur}
    multiline
    rows={3}
    fullWidth
    sx={{ bgcolor: 'background.paperDark' }}
    placeholder="Add any notes or comments about this pending accreditation"
  />
)

export let DateField = ({
  field,
  label,
}: {
  field: any
  label: string
}): ReactElement => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      label={label}
      value={field.state.value ? dayjs(field.state.value) : null}
      onChange={(val) =>
        field.handleChange(val ? val.format('YYYY-MM-DD') : '')
      }
      onClose={field.handleBlur}
      slotProps={{
        textField: {
          fullWidth: true,
          sx: { bgcolor: 'background.paperDark' },
          onBlur: field.handleBlur,
        },
      }}
    />
  </LocalizationProvider>
)

export let FieldsRow = ({
  children,
}: {
  children: React.ReactNode
}): ReactElement => <Box className="grid grid-cols-2 gap-4">{children}</Box>
